var map = {
	"./ability.png": 4230,
	"./arrow.png": 7139,
	"./block-bg.png": 3334,
	"./car.png": 3302,
	"./coding.png": 2622,
	"./coins.png": 7096,
	"./computer.png": 8433,
	"./cooperate.png": 281,
	"./cooperation.png": 4041,
	"./custom.png": 5749,
	"./customer_code.png": 7860,
	"./data-master-1.png": 6146,
	"./data-master-2.png": 4221,
	"./data-master-3.png": 2019,
	"./data-master-4.png": 7358,
	"./data-master.png": 8342,
	"./drop.png": 5753,
	"./drop2.png": 7343,
	"./earth.png": 3436,
	"./email_icon.png": 6115,
	"./experience-1.png": 480,
	"./experience-2.png": 9327,
	"./field.png": 5496,
	"./hand.png": 6418,
	"./head.png": 8257,
	"./honest.png": 1390,
	"./house.png": 9211,
	"./icon-arrow-right.png": 2430,
	"./icon-comments-active.png": 9415,
	"./icon-comments.png": 2206,
	"./icon-flag.png": 6359,
	"./icon-phone-telephone-active.png": 7035,
	"./icon-phone-telephone.png": 5695,
	"./index-1.png": 6737,
	"./index-2.png": 6749,
	"./index-3.png": 4348,
	"./index-4.png": 8274,
	"./index-head-1.png": 338,
	"./index-head-2.png": 7879,
	"./index-head-3.png": 8428,
	"./index-head-4.png": 2513,
	"./index-head-5.png": 9690,
	"./left-arrow.png": 4238,
	"./lighthouse1.png": 2444,
	"./lighthouse2.png": 973,
	"./lighthouse3.png": 3243,
	"./lighthouse4.png": 762,
	"./lighthouse5.png": 5221,
	"./lighthouse6.png": 5894,
	"./lighthouse_icon.png": 3697,
	"./location_icon.png": 1814,
	"./logo.png": 6949,
	"./logo2.png": 1637,
	"./manage.png": 7106,
	"./map.png": 3808,
	"./model1.png": 6039,
	"./model2.png": 3693,
	"./model3.png": 154,
	"./model4.png": 8189,
	"./model5.png": 123,
	"./model6.png": 7229,
	"./module-1.png": 4805,
	"./module-2.png": 1103,
	"./module-3.png": 9650,
	"./module-lyf.png": 4552,
	"./monitor.png": 8050,
	"./news1.png": 2523,
	"./news2.png": 8180,
	"./news3.png": 9904,
	"./news4.png": 2543,
	"./no_rule.png": 1889,
	"./office_code.png": 2801,
	"./operate-1.png": 8273,
	"./operate-2.png": 9856,
	"./operate-3.png": 3716,
	"./operate-4.png": 3134,
	"./operate-5.png": 8894,
	"./operate-6.png": 6795,
	"./operate-7.png": 8508,
	"./p-2.png": 6053,
	"./p-3.png": 9234,
	"./p-4.png": 2287,
	"./p-5.png": 6673,
	"./partner1.png": 1633,
	"./partner2.png": 6393,
	"./partner3.png": 7559,
	"./partner4.png": 9323,
	"./partner5.png": 3822,
	"./partner6.png": 5407,
	"./partner_icon.png": 5698,
	"./path1.png": 8624,
	"./path2.png": 2610,
	"./path3.png": 5898,
	"./path4.png": 1691,
	"./price-1.png": 4476,
	"./price-2.png": 23,
	"./price-3.png": 6134,
	"./price1.png": 4402,
	"./price2.png": 6726,
	"./price3.png": 6193,
	"./price4.png": 3905,
	"./price5.png": 9260,
	"./price_icon.png": 1961,
	"./process-arrow.png": 4563,
	"./process-arrow2.png": 924,
	"./produce-bg.png": 8446,
	"./produce1.png": 4390,
	"./produce2.png": 1862,
	"./produce3.png": 1859,
	"./produce4.png": 7804,
	"./produce5.png": 3813,
	"./produce_supply_banner.png": 2292,
	"./product-1.png": 6417,
	"./product-2.png": 5565,
	"./product-3.png": 2224,
	"./product-4.png": 7030,
	"./product-card-1.png": 1708,
	"./product-card-2.png": 368,
	"./product-service-1.png": 7159,
	"./product-service-2.png": 5446,
	"./product-service-3.png": 7546,
	"./product-theory.png": 8727,
	"./product_bottom_1.png": 6671,
	"./product_bottom_2.png": 4621,
	"./product_bottom_3.png": 5692,
	"./product_bottom_4.png": 937,
	"./product_icon_1.png": 690,
	"./product_icon_2.png": 4248,
	"./product_icon_3.png": 5011,
	"./product_icon_4.png": 5267,
	"./quotation1.png": 387,
	"./quotation2.png": 2030,
	"./right-arrow.png": 7898,
	"./rise.png": 2246,
	"./rise2.png": 4722,
	"./service.png": 3382,
	"./shortage.png": 7461,
	"./standard.png": 7587,
	"./storage.png": 9398,
	"./supply_chain1.png": 9144,
	"./supply_chain10.png": 9700,
	"./supply_chain2.png": 7794,
	"./supply_chain3.png": 2530,
	"./supply_chain4.png": 9360,
	"./supply_chain5.png": 4981,
	"./supply_chain6.png": 3920,
	"./supply_chain7.png": 8200,
	"./supply_chain8.png": 645,
	"./supply_chain9.png": 3071,
	"./supply_chain_icon.png": 8639,
	"./supply_icon.png": 359,
	"./tool1.png": 8885,
	"./tool2.png": 293,
	"./tool3.png": 6706,
	"./tool4.png": 5301,
	"./tool5.png": 1734,
	"./tool6.png": 421,
	"./transfer.png": 7352,
	"./triangle-right.png": 1244,
	"./unclear.png": 7554,
	"./uncontrol.png": 2151,
	"./unsalable.png": 7768,
	"./value1.png": 3773,
	"./value2.png": 8820,
	"./value3.png": 9538,
	"./value4.png": 5140,
	"./value5.png": 8191,
	"./value6.png": 9677,
	"./wastage.png": 2755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;